module.exports = __webpack_public_path__ + "static/media/shower_icon.62b6d2a0.svg";